export default __webpack_public_path__ + "static/media/iban_icon.6a74682f.png";